export abstract class APlugin {
  protected abstract formElement: HTMLFormElement;
  protected abstract buildElementList(): void;
}
